import {
  InsuranceType,
  ProductBackendName,
} from "Components/Features/CheckPrice/Products/productTypes";
import { useComponentTexts, useInsuranceCoverages } from "Store/texts/hooks";
import {
  dropIrrelevantCoverage,
  getCoveragesFromInsuranceType,
  getRelevantHeaders,
  insuranceTypeFromInsuranceCoverage,
} from "./coverages.helpers";
import {
  AccordionHeader,
  AccordionHeaderRow,
  Box,
  CoverageBoxes,
  CoverageCaption,
  CoverageContent,
  HeaderBox,
  StyledAccordion,
  StyledAccordionRow,
} from "./coverages.styles";

import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { buttonTrackId } from "Utils/analytics";
import React from "react";
import { IsIncludedCoverage } from "./IsIncludedCoverage";

interface Props {
  readonly selected: InsuranceCoverage;
  readonly product: ProductBackendName;
  readonly doNotShow?: InsuranceType;
}

export const CoverageComparisonAccordion = ({
  product,
  selected,
  doNotShow,
}: Props): React.ReactElement => {
  const coverages = dropIrrelevantCoverage(
    useInsuranceCoverages(product),
    insuranceTypeFromInsuranceCoverage(selected),
    doNotShow,
  );
  const [{ coverageAccordion2 }, lang] = useComponentTexts();
  const headers = getRelevantHeaders(coverageAccordion2, product, coverages);

  return (
    <>
      <AccordionHeaderRow
        id="coverage-comparison-accordion-header-row"
        headerProps={{
          type: "button",
        }}
        header={
          <AccordionHeader>
            <p>{coverageAccordion2.header[lang]}</p>
            <CoverageBoxes>
              {headers.map(([key, value]) => (
                <HeaderBox
                  key={key}
                  selected={getCoveragesFromInsuranceType(key).includes(
                    selected,
                  )}
                >
                  <p>{value[lang]}</p>
                </HeaderBox>
              ))}
            </CoverageBoxes>
          </AccordionHeader>
        }
        hideIcon
      />
      <StyledAccordion>
        {coverages.map((coverage) => {
          return (
            <StyledAccordionRow
              id={`${coverage.caption[lang]}-coverage-comparison-accordion-row`}
              key={coverage.caption[lang]}
              headerProps={{
                type: "button",
              }}
              header={
                <AccordionHeader
                  data-trackid={buttonTrackId("coverage-comparison-row")}
                >
                  <CoverageCaption id={`${coverage.caption[lang]}-caption`}>
                    {coverage.caption[lang]}
                  </CoverageCaption>
                  <CoverageBoxes>
                    {headers.map(([key]) => (
                      <Box
                        key={key}
                        selected={getCoveragesFromInsuranceType(key).includes(
                          selected,
                        )}
                      >
                        <IsIncludedCoverage included={coverage[key]} />
                      </Box>
                    ))}
                  </CoverageBoxes>
                </AccordionHeader>
              }
              content={coverage.explanation[lang].map((explanation: string) => (
                <CoverageContent key={explanation} linkTarget="_blank">
                  {explanation}
                </CoverageContent>
              ))}
              hideIcon
            />
          );
        })}
      </StyledAccordion>
    </>
  );
};
